<template>
  <v-card>
    <v-layout mx-4 wrap>
      <v-flex md12>
        <v-select
          :items="leadSources"
          v-model="customer.leadSource"
          label="Como chegou até nós?"
        ></v-select>
      </v-flex>
      <v-flex md12 v-if="customer.leadSource === leadSources[0]">
        <v-select
          :items="socialMediaSources"
          v-model="customer.leadSourceType"
          label="Qual Rede?"
        ></v-select>
      </v-flex>
      <v-flex md12 v-if="customer.leadSource === leadSources[1]">
        <v-select
          :items="referralSources"
          v-model="customer.leadSourceType"
          label="De Quem?"
        ></v-select>
      </v-flex>
      <v-flex md12 v-if="customer.leadSource === leadSources[2]">
        <v-select
          :items="adSources"
          v-model="customer.leadSourceType"
          label="Que tipo?"
        ></v-select>
      </v-flex>
      <v-flex
        md12
        v-if="
          customer.leadSource != leadSources[0] ||
            customer.leadSourceType === leadSources[leadSources.length - 1]
        "
      >
        <v-text-field
          name="leadSourceNotes"
          label="Detalhes"
          id="leadSourceNotes"
          v-model="customer.leadSourceNotes"
        ></v-text-field>
      </v-flex>
      <v-flex md12>
        <v-textarea
          name="notes"
          label="Anotações"
          v-model="customer.notes"
        ></v-textarea>
      </v-flex>
    </v-layout>
  </v-card>
</template>
<script>
export default {
  props: ["customer"],
  data: function() {
    return {
      leadSources: [
        "Redes Sociais",
        "Recomendação",
        "Propaganda",
        "Website da Agência",
        "Outros"
      ],
      socialMediaSources: [
        "Instagram World",
        "Instagram Rafa",
        "Instagram Disney",
        "Outros"
      ],
      referralSources: ["Parceiro", "Cliente World", "Outros"],
      adSources: ["Impresso", "Rádio", "TV", "Outros"]
    };
  }
};
</script>
